import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MailIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75a2.25 2.25 0 012.25-2.25h2.25A.75.75 0 017.5 5.25v2.25a.75.75 0 01-.22.53l-1.5 1.5a16.5 16.5 0 008.47 8.47l1.5-1.5a.75.75 0 01.53-.22h2.25a.75.75 0 01.75.75v2.25a2.25 2.25 0 01-2.25 2.25A15.75 15.75 0 012.25 6.75z" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);

const ClockIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const contacts = [
  { name: 'James Konstantinakos', role: 'Principal', email: 'jkonstantinakos@schools.nyc.gov' },
  { name: 'David Ledesma', role: 'Assistant Principal', email: 'dledesma@schools.nyc.gov' },
  { name: 'Dr. Mallory Locke', role: 'Assistant Principal', email: 'mlocke4@schools.nyc.gov' },
  { name: 'Arlette Martinez Medrano', role: 'Parent Coordinator', email: 'amartinezmedrano2@schools.nyc.gov' },
  { name: 'Janet Cruz', role: 'School Secretary', email: 'jcruz28@schools.nyc.gov' },
];

const ContactUsPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />

    <main id="main-content" className="pt-0">
      {/* Hero */}
      <section
        className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
      >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

        <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <span className="text-sm font-semibold text-white tracking-tight">Get in Touch</span>
            </div>
          </div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            Contact Us
          </h1>
          <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mx-auto">
            We're here to help. Reach out to our team by phone, email, or in person.
          </p>
        </div>
      </section>

      {/* Info cards */}
      <section className="max-w-6xl mx-auto px-6 lg:px-8 mt-12 mb-16">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            {
              icon: <LocationIcon />,
              title: 'Visit Us',
              lines: ['216 E 120th Street', 'New York, NY 10035', 'East Harlem'],
              action: { label: 'Get Directions', href: '/directions' },
            },
            {
              icon: <PhoneIcon />,
              title: 'Call Us',
              lines: ['Main Office: (212) 860-5851', 'Fax: (212) 860-6074'],
              action: { label: 'Call now', href: 'tel:+12128605851' },
            },
            {
              icon: <ClockIcon />,
              title: 'Office Hours',
              lines: ['Monday – Friday', '7:30 AM – 4:00 PM', 'School days only'],
              action: null,
            },
          ].map((card) => (
            <div key={card.title} className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
              <div className="w-12 h-12 rounded-lg bg-[#fdbb2e]/10 flex items-center justify-center text-[#00213a] mb-4">
                {card.icon}
              </div>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">{card.title}</h2>
              <div className="space-y-1 text-sm text-gray-600 mb-4">
                {card.lines.map((l) => <p key={l}>{l}</p>)}
              </div>
              {card.action && (
                <a href={card.action.href} className="text-sm font-bold text-[#00213a] hover:underline">
                  {card.action.label} →
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Key contacts */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-gray-200 mb-4">
              <span className="text-sm font-semibold text-gray-700">Key Contacts</span>
            </div>
            <h2 className="text-4xl font-semibold text-gray-900 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
              Who to Reach
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {contacts.map((c) => (
              <div key={c.email} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md hover:border-[#fdbb2e]/30 transition-all duration-200">
                <p className="font-semibold text-gray-900 mb-1">{c.name}</p>
                <p className="text-sm text-[#00213a] font-medium mb-3">{c.role}</p>
                <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-[#00213a] transition-colors duration-150">
                  <MailIcon />
                  {c.email}
                </a>
              </div>
            ))}
          </div>
          <p className="mt-8 text-sm text-gray-500">
            For the full staff directory, visit our{' '}
            <a href="/directory/faculty" className="text-[#00213a] font-semibold hover:underline">Faculty & Staff page</a>.
          </p>
        </div>
      </section>

      {/* Map */}
      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-20">
        <h2 className="text-3xl font-semibold text-gray-900 mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
          Find Us
        </h2>
        <div className="rounded-xl overflow-hidden border border-gray-200 shadow-md" style={{ height: '400px' }}>
          <iframe
            title="PS 96 Location"
            className="w-full h-full"
            src="https://www.google.com/maps?q=216+E+120th+St,+New+York,+NY+10035&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ContactUsPage;
